import SvgIcon, { SvgIconProps } from '@material-ui/core/SvgIcon'
import React from 'react'

const Twitter = (props: SvgIconProps) => {
  return (
    <SvgIcon {...props} viewBox="0 0 18 18">
      <path
        d="M10.712 7.622L17.413 0h-1.588l-5.818 6.618L5.36 0H0l7.027 10.007L0 18h1.588l6.144-6.989L12.64 18H18L10.712 7.622zm-2.175 2.474l-.712-.997L2.16 1.17H4.6l4.571 6.4.712.996 5.943 8.318h-2.439l-4.85-6.787z"
        fill="currentColor"
      />
    </SvgIcon>
  )
}

export default Twitter
